import { axios, axios2 } from '@/lib/axios';
import { ApiResponse, FaqContent } from '@/types';

export type contentManagementDTO = {
  title: string;
  content: string;
};

export const addFaq = (data: contentManagementDTO): Promise<ApiResponse<FaqContent>> => {
  return axios.post('/admin-api/add-faq', data);
};

export const addAgencyFaq = (data: contentManagementDTO): Promise<ApiResponse<FaqContent>> => {
  return axios2.post('/admin-api/agency-add-faq', data);
};
